<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
// import PageHeader from "@/components/page-header";

// import Stat from "@/components/widgets/stat";

/**
 * Dashboard Component
 */
export default {
   page: {
      title: "Dashboard",
      meta: [
         {
            name: "description",
            content: appConfig.description,
         },
      ],
   },
   components: {
      Layout,
      // PageHeader,
      // Stat,
   },
   data() { 
      return {
         title: "Dashboard",
         items: [
            {
               text: "Dashboard",
               active: true,
            },        
         ],
      
         isLoading: false,
         total_pending: 0,
         delayed_orders: 0,


         pieChart: {
         series: [],
         chartOptions: {
            labels: [
               "Pending",
               "Assigned",
               "Ongoing",
               "Delivered",
               "Cancelled",
            ],
            colors: [
               "#f7e860",
               "#8b9ef5",
               "#cb86d7",
               "#34c38f",
               "#f46a6a",
            ],
            legend: {
               show: true,
               position: "bottom",
               horizontalAlign: "center",
               verticalAlign: "middle",
               floating: false,
               fontSize: "14px",
               offsetX: 0,
            },
            responsive: [
               {
               breakpoint: 600,
               options: {
                  chart: {
                     height: 240,
                  },
                  legend: {
                     show: false,
                  },
               },
               },
            ],
         },
         }, // pieChart ends


         //Type of all orders
         pieChart2: {
         series: [],
         chartOptions: {
            labels: ["Online", "Store"],
            colors: ["#cb86d7", "#34c38f"],
            legend: {
               show: true,
               position: "bottom",
               horizontalAlign: "center",
               verticalAlign: "middle",
               floating: false,
               fontSize: "14px",
               offsetX: 0,
            },
            responsive: [
               {
               breakpoint: 600,
               options: {
                  chart: {
                     height: 240,
                  },
                  legend: {
                     show: false,
                  },
               },
               },
            ],
         },
         }, // pieChart ends

         today_online_orders: 0,
         this_week_online_orders: 0,
         this_month_online_orders: 0,
         total_online_orders: 0,
         today_offline_orders: 0,
         this_week_offline_orders: 0,
         this_month_offline_orders: 0,
         total_offline_orders: 0,
         total_orders: 0,
         

      };
   },
   mounted() {

   },

   created() {
      this.fetchDashboard();
      this.fetchDelayedOrders();
   },

   methods: {
      setPlace(loc) {
         this.currentLocation = loc;
      },
      

      fetchDashboard() {
         this.getToken();       
         let url = "store/store/dashboard";
         this.loading = true;
         this.$axios
         .get(url, { headers: { Authorization: "Bearer " + this.token } })
         .then((res) => {
            var data = res.data.data;
            console.log(data); 
            console.log(res);
            if(res.status == 200) {
               
               console.log(data);

               this.today_online_orders = data.today_online_orders;
               this.this_week_online_orders = data.this_week_online_orders;
               this.this_month_online_orders = data.this_month_online_orders;
               this.total_online_orders = data.total_online_orders;

               this.today_offline_orders = data.today_offline_orders;
               this.this_week_offline_orders = data.this_week_offline_orders;
               this.this_month_offline_orders = data.this_month_offline_orders;
               this.total_offline_orders = data.total_offline_orders;

               this.total_orders = data.total_orders;

               this.pieChart.series[0] = data.pending;
               this.pieChart.series[1] = data.assigned;
               this.pieChart.series[2] = data.ongoing;
               this.pieChart.series[3] = data.delivered;
               this.pieChart.series[4] = data.cancelled;

               this.pieChart2.series[0] = data.online;
               this.pieChart2.series[1] = data.store;
              
            } else {
               this.$swal("", "Something went wrong", "error");
            }
         })
         .catch((error) => {
            console.log(error);
            console.log(error.response);
            if (error.response) {
               if(error.response.status == 422) {               
                  if (error.response.data) {
                     this.errors = error.response.data.message;
                  } 
                  this.$swal("", error.response.statusText, "error");
                  
               } else if(error.response.status == 500) {
                  this.$swal("", error.response.statusText, "error");

               } else if(error.response.status == 401) {
                  this.$swal("", error.response.statusText, "error");
                  this.$router.push({ name: "login" });

               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            } else {
               this.$swal("", error.message, "error");
            }
            
         });
      },

      getToken() {
         if (localStorage.getItem('sigofish_store')) {
            var sigofish_store =  JSON.parse(localStorage.getItem('sigofish_store'));
            if(sigofish_store.token) {
               this.token = sigofish_store.token;
            } else {
               this.$swal("", "Failed to fetch token, please login again", "error");
               this.$router.push({ name: "login" });
            }
               
         } else {
            this.$swal("", "Session expired, please login again", "error");
            this.$router.push({ name: "login" });
         }
      }, 

      fetchDelayedOrders() {
            let url = "store/orders/delayed_orders";         
            this.getToken();
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.total_pending = responseData.total_pending;
                  this.delayed_orders = responseData.delayed_orders;
            })
            .catch((err) => console.log(err));
      },



   }
};
</script>

<template>
   <Layout>
      <!-- <PageHeader :title="title" :items="items" /> -->
      <div class="row">
         <div class="col-12">
            <div class="page-title-box d-flex align-items-center justify-content-between">
            <h4 class="mb-0 font-size-18">DASHBOARD</h4>

            <div class="page-title-right">
               <router-link :to="{ name: 'online.orders' , params:{status:6}}" class="btn btn-danger me-2 mb-2 " >Delayed Orders : {{delayed_orders}}</router-link>
               <router-link :to="{ name: 'online.orders',  params:{status:1}}" class="btn btn-danger me-2 mb-2 " >Pending Orders : {{total_pending}}</router-link>
            </div>
            </div>
         </div>
      </div>


      <div class="row mb-4">

         <div class="col-md-6">
            <div class="card mini-stats-wid">
               <div class="card-body">
                  <div class="media mb-3">
                     <div class="media-body">
                        <p class="text-muted fw-medium mb-2 font-size-18">Online Orders</p>
                     </div>

                     <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
                        <span class="avatar-title">
                           <i class="fas fa-shopping-cart font-size-22"></i>
                        </span>
                     </div>
                  </div>

                  <div class="media mb-2">
                     <div class="media-body">
                        <p class="text-muted fw-medium mb-2">Today</p>
                     </div>

                     <div class="align-self-center ">
                        <span class="float-end me-3">
                           <h4 class="mb-0 font-size-16">{{today_online_orders}}</h4>
                        </span>
                     </div>
                  </div>

                  <div class="media mb-2">
                     <div class="media-body">
                        <p class="text-muted fw-medium mb-2">This week</p>
                     </div>

                     <div class="align-self-center ">
                        <span class="float-end me-3">
                           <h4 class="mb-0 font-size-16">{{this_week_online_orders}}</h4>
                        </span>
                     </div>
                  </div>

                  <div class="media mb-2">
                     <div class="media-body">
                        <p class="text-muted fw-medium mb-2">This month</p>
                     </div>

                     <div class="align-self-center ">
                        <span class="float-end me-3">
                           <h4 class="mb-0 font-size-16">{{this_month_online_orders}}</h4>
                        </span>
                     </div>
                  </div>

                  <div class="media">
                     <div class="media-body">
                        <p class="text-muted fw-medium mb-2">Total</p>
                     </div>

                     <div class="align-self-center ">
                        <span class="float-end me-3">
                           <h4 class="mb-0 font-size-16">{{total_online_orders}}</h4>
                        </span>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <div class="col-md-6">
            <div class="card mini-stats-wid">
               <div class="card-body">
                  <div class="media mb-3">
                     <div class="media-body">
                        <p class="text-muted fw-medium mb-2 font-size-18">Store Orders</p>
                     </div>

                     <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
                        <span class="avatar-title">
                           <i class="fas fa-store font-size-22"></i>
                        </span>
                     </div>
                  </div>

                  <div class="media mb-2">
                     <div class="media-body">
                        <p class="text-muted fw-medium mb-2">Today</p>
                     </div>

                     <div class="align-self-center ">
                        <span class="float-end me-3">
                           <h4 class="mb-0 font-size-16">{{today_offline_orders}}</h4>
                        </span>
                     </div>
                  </div>

                  <div class="media mb-2">
                     <div class="media-body">
                        <p class="text-muted fw-medium mb-2">This week</p>
                     </div>

                     <div class="align-self-center ">
                        <span class="float-end me-3">
                           <h4 class="mb-0 font-size-16">{{this_week_offline_orders}}</h4>
                        </span>
                     </div>
                  </div>

                  <div class="media mb-2">
                     <div class="media-body">
                        <p class="text-muted fw-medium mb-2">This month</p>
                     </div>

                     <div class="align-self-center ">
                        <span class="float-end me-3">
                           <h4 class="mb-0 font-size-16">{{this_month_offline_orders}}</h4>
                        </span>
                     </div>
                  </div>

                  <div class="media">
                     <div class="media-body">
                        <p class="text-muted fw-medium mb-2">Total</p>
                     </div>

                     <div class="align-self-center ">
                        <span class="float-end me-3">
                           <h4 class="mb-0 font-size-16">{{total_offline_orders}}</h4>
                        </span>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         
         <!-- <div class="col-md-4">
            <Stat icon="fas fa-shopping-cart" title="Today's Online Orders" :value="today_online_orders" />
         </div> 

         <div class="col-md-4">
            <Stat icon="fas fa-store" title="Today's Store Orders" :value="today_offline_orders" />
         </div> 

         <div class="col-md-4">
            <Stat icon="fas fa-shopping-cart" title="This Week's Online Orders" :value="this_week_online_orders" />
         </div> 

         <div class="col-md-4">
            <Stat icon="fas fa-store" title="This Week's Store Orders" :value="this_week_offline_orders" />
         </div> 

         <div class="col-md-4">
            <Stat icon="fas fa-shopping-cart" title="This Month's Online Orders" :value="this_month_online_orders" />
         </div> 

         <div class="col-md-4">
            <Stat icon="fas fa-store" title="This Month's  Store Orders" :value="this_month_offline_orders" />
         </div> 

         <div class="col-md-4">
            <Stat icon="fas fa-shopping-cart" title="Total Online Orders" :value="total_online_orders" />
         </div> 


         <div class="col-md-4">
            <Stat icon="fas fa-store" title="Total Store Orders" :value="total_offline_orders" />
         </div>  -->

      </div>

      <div class="row mb-5">
         <div class="col-md-6">
            <div class="card h-100">
               <div class="card-body">
                  <h4 class="font-size-20 p-3 mb-3">Order Status</h4>
                  <apexchart
                  v-if="pieChart.series.length"
                  class="apex-charts"
                  height="320"
                  type="pie"
                  dir="ltr"
                  :series="pieChart.series"
                  :options="pieChart.chartOptions"
                  ></apexchart>
               </div>
            </div>
         </div>

         <div class="col-md-6">
            <div class="card h-100">
               <div class="card-body">
                  <h4 class="font-size-20 p-3 mb-3">Order Types</h4>
                  <apexchart
                  v-if="pieChart2.series.length"
                  class="apex-charts"
                  height="320"
                  type="pie"
                  dir="ltr"
                  :series="pieChart2.series"
                  :options="pieChart2.chartOptions"
                  ></apexchart>
               </div>
            </div>
         </div>
      </div>   
     
   </Layout>
</template>
